import { render, staticRenderFns } from "./language-switcher.vue?vue&type=template&id=88f168f4"
import script from "./language-switcher.vue?vue&type=script&lang=js"
export * from "./language-switcher.vue?vue&type=script&lang=js"
import style0 from "./language-switcher.vue?vue&type=style&index=0&id=88f168f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports